import { LookupId, PropertyPath } from '../engine.js';

export interface ResolutionSchemaDefinition {
  products: ProductResolutionSchemaDefinition[];
}

export interface ProductResolutionSchemaDefinition {
  type: string;
  resolutionSchema: ResolutionSchemaDeclaration;
}

export type LookupRecord = SinglePropertyLookupRecord | MultiPropertyLookupRecord | ExtendedSinglePropertyLookupRecord; // | CrossLookupRecord;

export type JsExpression = string;
export type Variation = (LookupId | LookupId[])[];
export type Fixed = LookupId[];

export interface SinglePropertyLookupRecord {
  id: string;
  option: PropertyPath;
  property: PropertyPath;
  fixed: Fixed;
  variation: Variation;
  filterGroup: string;
}

export interface ExtendedSinglePropertyLookupRecord {
  id: string;
  option: PropertyPath;
  key: string;
  properties: { [key: string]: PropertyPath }
  fixed: Fixed;
  variation: Variation;
  aggregateExpression?: JsExpression;
  filterGroup: string;
}

export interface MultiPropertyLookupRecord {
  id: string;
  option: PropertyPath;
  properties: { [key: string]: PropertyPath }
  fixed: Fixed;
  variation: Variation;
  filterGroup: string;
}

// export interface CrossLookupRecord {
//   id: string;
//   name: string;
//   lookups: SinglePropertyLookupRecord[];
//   jsPredicate?: JsSnippet; // default ==
//   jsSelector: JsSnippet;
// }

export interface ResolutionSchemaDeclaration {
  lookups: LookupRecord[];
}

export function singlePropertyLookupTypeGuard(value: LookupRecord): value is SinglePropertyLookupRecord {
  return value && value['option'] && value['property'];
}

export function multiPropertiesLookupRecordTypeGuard(value: LookupRecord): value is MultiPropertyLookupRecord {
  return value && value['option'] && value['properties'] && !value['key'];
}

export function extendedSinglePropertyLookupTypeGuard(value: LookupRecord): value is ExtendedSinglePropertyLookupRecord {
  return value && value['option'] && value['key'] && value['properties'];
}

//TODO: Implement in the future
// export function crossLookupRecordTypeGuard(value: LookupRecord): value is CrossLookupRecord {
//   return value && value['lookups'] && value['name'];
// }
export function oneOptionLookupRecordTypeGuard(value: LookupRecord): value is SinglePropertyLookupRecord | MultiPropertyLookupRecord {
  return singlePropertyLookupTypeGuard(value) || multiPropertiesLookupRecordTypeGuard(value) || extendedSinglePropertyLookupTypeGuard(value);
}
